module.exports = __webpack_public_path__ + "static/media/HKJC_Charities_Trust_Logo.4843014c.png";